import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Target, TrendingUp } from 'lucide-react';

export default function OrganizationsChart({ dashboardData, sortBy }) {
  const getChartData = () => {
    if (!dashboardData?.top_organizations?.organizations?.length) return [];
    
    return dashboardData.top_organizations.organizations.map(org => ({
      name: org.name.length > 15 ? `${org.name.substring(0, 15)}...` : org.name,
      value: sortBy === 'users' ? org.users_count : sortBy === 'processes' ? org.processes_count : org.risks_count,
      fullName: org.name
    }));
  };

  const getColor = () => {
    switch(sortBy) {
      case 'processes': return '#10b981';
      case 'risks': return '#ef4444';
      default: return '#37c242ff';
    }
  };

  const getLabel = () => {
    switch(sortBy) {
      case 'processes': return 'Processus';
      case 'risks': return 'Risques';
      default: return 'Utilisateurs';
    }
  };

  const chartData = getChartData();

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-lg">
          <p className="text-sm font-semibold text-gray-900">{payload[0].payload.fullName}</p>
          <p className="text-sm font-bold" style={{ color: getColor() }}>
            {getLabel()}: {payload[0].value}
          </p>
        </div>
      );
    }
    return null;
  };

  if (!chartData.length) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4 h-80 flex items-center justify-center">
        <div className="text-center">
          <TrendingUp className="h-12 w-12 text-gray-300 mx-auto mb-2" />
          <p className="text-xs text-gray-500">Aucune donnée disponible</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Target className="h-4 w-4 text-green-600" />
          <h3 className="text-sm font-semibold text-gray-900">
            Graphique - {getLabel()}
          </h3>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 0, bottom: 60 }}
        >
          <defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={getColor()} stopOpacity={0.9}/>
              <stop offset="95%" stopColor={getColor()} stopOpacity={0.7}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="name"
            tick={{ fill: '#6b7280', fontSize: 12 }}
            angle={-45}
            textAnchor="end"
            height={100}
          />
          <YAxis
            tick={{ fill: '#6b7280', fontSize: 12 }}
            stroke="#e5e7eb"
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(59, 130, 246, 0.1)' }} />
          <Bar
            dataKey="value"
            fill="url(#colorGradient)"
            radius={[8, 8, 0, 0]}
            animationDuration={800}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}